module.exports = __webpack_public_path__ + "img/2015.376fdbe5.jpg";